import FolderId from 'owa-service/lib/contract/FolderId';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import getFolderRequest from 'owa-service/lib/factory/getFolderRequest';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import getFolderOperation from 'owa-service/lib/operation/getFolderOperation';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Retrieves ReplicaLists on the given folder ids
 * @param folderIds Folder ids
 */
export default function getReplicaLists(
    folderIds: FolderId[],
    options: RequestOptions
): Promise<FolderInfoResponseMessage[]> {
    return getFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: getFolderRequest({
                FolderShape: folderResponseShape({
                    BaseShape: 'IdOnly',
                    AdditionalProperties: [propertyUri({ FieldURI: 'ReplicaList' })],
                }),
                FolderIds: folderIds,
            }),
        },
        options
    ).then(response => {
        return response.Body.ResponseMessages.Items;
    });
}
